import React from 'react';
import useAppStore from '../../store/useAppStore.js';

const TokenPreview = ({ receiptItems, discount, selectedTable, token }) => {

    const { selectedBranch } = useAppStore((state) => ({
        selectedBranch: state.selectedBranch
    }));

    const shopName = selectedBranch?.name || "ICE CREAM WORLD";
    const orderTime = new Date().toLocaleString();
    const tokenNumber = token?.token_no || (selectedTable ? selectedTable.replace(/[^0-9]/g, '') : '001');
    const subtotal = (receiptItems && Array.isArray(receiptItems)) ? receiptItems.reduce((sum, item) => sum + item.price * item.quantity, 0) : 0;
    const discountValue = Math.min(Number(discount) || 0, subtotal);
    const grandTotal = subtotal - discountValue;

    return (
        <div className="space-y-3 text-xs border   text-gray-900 bg-white p-4 shadow-lg page-break-after print-show token-preview" style={{ width: '80mm', maxWidth: '100%', paddingTop: 0 }}>
            <div className="text-center font-bold tracking-widest">{shopName}</div>
            <div className="text-center text-[11px] uppercase text-gray-500">Pickup Token</div>
            <div className="flex flex-col items-center gap-2" >
                <span>Token No.</span>
                <h1 className="text-center font-bold text-lg border border-gray-300 p-4 rounded-full" >{tokenNumber}</h1>
            </div>

            <div className="border-b border-gray-300 py-3">
                <div className="flex justify-between">

                </div>
                <div className="flex justify-between pt-2">
                    <span>Order Time</span>
                    <span>{orderTime}</span>
                </div>
            </div>

            <div className="space-y-2">
                {receiptItems.length === 0 ? (
                    <div className="text-center text-gray-500">No items added.</div>
                ) : (
                    receiptItems.map((item) => (
                        <div key={item.id} className="space-y-1">
                            <div className="grid grid-cols-3 gap-2 font-semibold text-gray-900">
                                <div>{item.name}</div>
                                <div className="text-right">x{item.quantity}</div>
                                <div className="text-right">PKR {(item.price * item.quantity).toFixed(2)}</div>
                            </div>
                            <div className="text-[11px] text-gray-500">@ PKR {item.price.toFixed(2)}</div>
                        </div>
                    ))
                )}
            </div>

            <div className="text-right text-xs border-t border-gray-200 pt-2 font-semibold text-gray-900">
                Total PKR {subtotal.toFixed(2)}
            </div>
            <div className="text-right text-xs font-semibold text-gray-900">
                Discount PKR {discountValue.toFixed(2)}
            </div>
            <div className="text-right text-xs font-semibold text-gray-900">
                Total PKR {grandTotal.toFixed(2)}
            </div>
            <div className="text-center text-[11px] text-gray-700 border-t border-gray-200 pt-2 ">Thank you!</div>
        </div>
    );
};

export default TokenPreview;
